{
  "0101": "Portland, Maine",
  "0102": "Bangor, Maine",
  "0103": "Eastport, Maine",
  "0104": "Jackman, Maine",
  "0105": "Vanceboro, Maine",
  "0106": "Houlton, Maine",
  "0107": "Fort Fairfield, Maine",
  "0108": "Van Buren, Maine",
  "0109": "Madawaska, Maine",
  "0110": "Fort Kent, Maine",
  "0111": "Bath, Maine",
  "0112": "Bar Harbor, Maine",
  "0114": "Manchester, New Hampshire",
  "0115": "Calais, Maine",
  "0118": "Limestone, Maine",
  "0121": "Rockland, Maine",
  "0122": "Jonesport, Maine",
  "0127": "Bridgewater, Maine",
  "0131": "Portsmouth, New Hampshire",
  "0132": "Belfast, Maine",
  "0150": "Border Patrol Sector, Hodgdon, Maine",
  "0151": "Houlton Border Patrol, Houlton, Maine",
  "0152": "Searsport, Maine",
  "0153": "Jackman Border Patrol, Jackman, Maine",
  "0154": "Rangeley Border Patrol, Rangeley, Maine",
  "0155": "Van Buren Border Patrol, Van Buren, Maine",
  "0156": "Fort Fairfield Border Patrol, Fort Fairfield, Maine",
  "0157": "Calais Border Patrol, Calais, Maine",
  "0181": "Lebanon Airport, New Hampshire",
  "0182": "Manchester User Fee Airport, New Hampshire",
  "0201": "St. Albans, Vermont",
  "0203": "Richford, Vermont",
  "0206": "Beecher Falls, Vermont",
  "0207": "Burlington, Vermont",
  "0209": "Derby Line, Vermont",
  "0210": "Newport, Vermont",
  "0211": "Norton, Vermont",
  "0212": "Highgate Springs/Alburg, Vermont",
  "0214": "Swanton, Vermont",
  "0221": "Northeast Region, Boston, Massachusetts",
  "0250": "Border Patrol Sector, Swanton, Vermont",
  "0251": "Swanton Border Patrol, Swanton, Vermont",
  "0252": "Richford Border Patrol, Richford, Vermont",
  "0253": "Newport Vermont Border Patrol, Newport, Vermont",
  "0254": "Beecher Falls Border Patrol, Beecher Falls, Vermont",
  "0255": "Champlain Border Patrol, Champlain, New York",
  "0256": "Ogdensburg Border Patrol, Ogdensburg, New York",
  "0257": "Massena Border Patrol, Massena, New York",
  "0258": "Burke New York Border Patrol, Burke, New York",
  "0281": "Lebanon Airport, Lebanon, New Hampshire",
  "0401": "Boston, Massachusetts",
  "0402": "Springfield, Massachusetts",
  "0403": "Worcester, Massachusetts",
  "0404": "Gloucester, Massachusetts",
  "0405": "New Bedford, Massachusetts",
  "0406": "Plymouth, Massachusetts",
  "0407": "Fall River, Massachusetts",
  "0408": "Salem, Massachusetts",
  "0409": "Provincetown, Massachusetts",
  "0410": "Bridgeport, Connecticut",
  "0411": "Hartford, Connecticut",
  "0412": "New Haven, Connecticut",
  "0413": "New London, Connecticut",
  "0416": "Lawrence, Massachusetts",
  "0417": "Logan Airport, East Boston, Massachusetts",
  "0481": "Hanscom User Fee Airport, Bedford, Massachusetts",
  "0499": "Boston-Cartage Control, Boston, Massachusetts",
  "0501": "Newport, Rhode Island",
  "0502": "Providence, Rhode Island",
  "0503": "Mellville, Rhode Island",
  "0701": "Ogdensburg, New York",
  "0704": "Massena, New York",
  "0706": "Cape Vincent, New York",
  "0708": "Alexandria Bay, New York",
  "0709": "Burke, New York",
  "0712": "Champlain-Rouses Point, New York",
  "0714": "Clayton, New York",
  "0715": "Trout River, New York",
  "0799": "Champlain-Cartage Cont, Champlain, New York",
  "0901": "Buffalo-Niagara Falls, New York",
  "0903": "Rochester, New York",
  "0904": "Oswego, New York",
  "0905": "Sodus Point, New York",
  "0906": "Syracuse, New York",
  "0907": "Utica, New York",
  "0921": "Northeast Region, Boston Massachusetts",
  "0950": "Border Patrol Sector, Tonawanda, New York",
  "0951": "Buffalo Border Patrol, Tonawanda, New York",
  "0952": "Niagara Falls Border Patrol Station, Niagara Falls, New York",
  "0953": "Watertown Border Patrol, Wellesley Island, New York",
  "0954": "Fulton New York Border Patrol, Fulton, New York",
  "0971": "TNT Skypak, New York",
  "0972": "Swift Sure Courier Services, Buffalo, New York",
  "0978": "Syracuse International Airport, New York",
  "0979": "Buffalo Niagara International Airport, New York",
  "0981": "Binghamton Regional Airport, New York",
  "0983": "Ithaca Tompkins International Airport, New York",
  "1001": "New York, New York",
  "1002": "Albany, New York",
  "1003": "Newark, New Jersey",
  "1004": "Perth Amboy, New Jersey",
  "1005": "Long Island, New York",
  "1006": "Fishkill, New York",
  "1007": "Napanoch, New York",
  "1012": "John F. Kennedy Airport, New York",
  "1101": "Philadelphia, Pennsylvania",
  "1102": "Chester, Pennsylvania",
  "1103": "Wilmington, Delaware",
  "1104": "Pittsburgh, Pennsylvania",
  "1105": "Paulsboro, Pennsylvania",
  "1106": "Wilkes-Barre/Scranton, Pennsylvania",
  "1107": "Camden, New Jersey",
  "1108": "Philadelphia International Airport, Philadelphia, Pennsylvania",
  "1109": "Harrisburg, Pennsylvania",
  "1110": "Cherry Hill, New Jersey",
  "1119": "Allentown, Pennsylvania",
  "1181": "Allentown-Bethlehem, Philadelphia, Pennsylvania",
  "1182": "Atlantic City User Fee Airport, New Jersey",
  "1183": "Trenton/Mercer Country User Fee Airport, New Jersey",
  "1195": "UPS Courier Hub Facility, Pennsylvania",
  "1301": "Annapolis, Maryland",
  "1302": "Cambridge, Maryland",
  "1303": "Baltimore, Maryland",
  "1304": "Crisfield, Maryland",
  "1305": "Baltimore-Washington International Airport, Maryland",
  "1307": "Dover, Delaware",
  "1401": "Norfolk, Virginia",
  "1402": "Newport News, Virginia",
  "1403": "Norfolk Subport, Norfolk, Virginia",
  "1404": "Richmond-Petersburg, Virginia",
  "1405": "Harrisonburg, Virginia",
  "1406": "Cape Charles, Virginia",
  "1407": "Reedville, Virginia",
  "1408": "Hopewell, Virginia",
  "1409": "Charleston, West Virginia",
  "1410": "Front Royal, Virginia",
  "1411": "Fraudulent Document Lab, Virginia",
  "1481": "New River Valley Airport, Dublin, Virginia",
  "1501": "Wilmington, North Carolina",
  "1502": "Winston-Salem, North Carolina",
  "1503": "Durham, North Carolina",
  "1506": "Reidsville, North Carolina",
  "1511": "Beaufort-Morehead City, North Carolina",
  "1512": "Charlotte, North Carolina",
  "1599": "Wilmington Cartage Cont, Wilmington, North Carolina",
  "1601": "Charleston, South Carolina",
  "1602": "Georgetown, South Carolina",
  "1603": "Greenville-Spartanburg, South Carolina",
  "1604": "Columbia, South Carolina",
  "1608": "Greer, South Carolina",
  "1681": "Myrtle Beach International Airport, Myrtle Beach, South Carolina",
  "1701": "Brunswick, Georgia",
  "1703": "Savannah, Georgia",
  "1704": "Atlanta, Georgia",
  "1705": "Albany, Georgia",
  "1706": "Dalton, Georgia",
  "1709": "Hartsfield Airport, Atlanta, Georgia",
  "1755": "Port for Tracking, Savannah, Georgia",
  "1758": "Olympics Security, Atlanta, Georgia",
  "1759": "Atlanta-Olympics, Atlanta, Georgia",
  "1801": "Tampa, Florida",
  "1803": "Jacksonville, Florida",
  "1804": "Tallahassee, Florida",
  "1805": "Fernandina Beach, Florida",
  "1806": "Carrabelle, Florida",
  "1807": "Boca Grande, Florida",
  "1808": "Orlando, Florida",
  "1809": "Orlando-Sanford Airport, Sanford, Florida",
  "1811": "Sarasota/Bradenton, Manatee, Florida",
  "1814": "St. Petersburg, Florida",
  "1816": "Port Canaveral, Florida",
  "1817": "Apalachicola, Florida",
  "1818": "Panama City, Florida",
  "1819": "Pensacola, Florida",
  "1820": "Port St. Joe, Florida",
  "1821": "Port Manatee, Florida",
  "1822": "Fort Myers, Florida",
  "1851": "Tampa Border Patrol, Tampa, Florida",
  "1852": "Jacksonville Border Patrol, Jacksonville, Florida",
  "1853": "Orlando Border Patrol, Orlando, Florida",
  "1881": "Southwest Florida Fort, Myers, Florida",
  "1882": "Sanford Regional Airport, Sanford, Florida",
  "1883": "Sarasota-Bradenton Airport, Sarasota, Florida",
  "1884": "Daytona Beach International Airport, Daytona Beach, Florida",
  "1885": "Melbourne Regional Airport, Melbourne, Florida",
  "1886": "Ocala Regional Airport, Ocala, Florida",
  "1899": "Tampa Cartage Control, Tampa, Florida",
  "1901": "Mobile, Alabama",
  "1902": "Gulfport, Mississippi",
  "1903": "Pascagoula, Mississippi",
  "1904": "Birmingham, Alabama",
  "1905": "Apalachicola, Florida",
  "1906": "Carrabelle, Florida",
  "1907": "Panama City, Florida",
  "1908": "Pensacola, Florida",
  "1909": "Port St. Joe, Florida",
  "1910": "Huntsville, Alabama",
  "1951": "Gulfport Border Patrol, Gulfport, Mississippi",
  "1952": "Mobile Border Patrol, Mobile, Alabama",
  "2001": "Morgan City, Louisiana",
  "2002": "New Orleans, Louisiana",
  "2003": "Little Rock, Arkansas",
  "2004": "Baton Rouge, Louisiana",
  "2005": "Port Sulphur, Louisiana",
  "2006": "Memphis, Tennessee",
  "2007": "Nashville, Tennessee",
  "2008": "Chattanooga, Tennessee",
  "2009": "Destrehan, Louisiana",
  "2010": "Gramercy, Louisiana",
  "2011": "Greenville, Mississippi",
  "2012": "Avondale, Louisiana",
  "2013": "St. Rose, Louisiana",
  "2014": "Good Hope, Louisiana",
  "2015": "Vicksburg, Mississippi (Include Jackson Municipal Airport)",
  "2016": "Knoxville, Tennessee",
  "2017": "Lake Charles, Louisiana",
  "2018": "Shreveport-Bossier City, Louisiana",
  "2019": "Lake Charles, Louisiana",
  "2020": "Lake Charles, Louisiana",
  "2023": "Lafayette, Louisiana",
  "2024": "Ft. Smith, Arkansas",
  "2025": "Fayetteville, Arkansas",
  "2026": "Texarkana, Arkansas",
  "2027": "Tri-City User Fee Airport, Blountville, Tennessee",
  "2050": "Border Patrol Sector, New Orleans, Louisiana",
  "2051": "Lake Charles Border Patrol, Lake Charles, Louisiana",
  "2052": "Baton Rouge Border Patrol, Baton Rouge, Louisiana",
  "2053": "New Orleans Border Patrol, New Orleans, Louisiana",
  "2054": "Little Rock Border Patrol, Little Rock, Arkansas",
  "2081": "Jackson Airport, Jackson, Mississippi",
  "2083": "Arkansas Aesoplex, Blythville, Tennessee",
  "2084": "Rogers Municipal Airport/Carter, Rogers, Arkansas",
  "2095": "Federal Express Courier, Memphis, Tennessee",
  "2097": "Nashville, Tennessee Cartage-Con, New Orleans, Louisiana",
  "2098": "Memphis, Tennessee Cartage-Control, New Orleans, Louisiana",
  "2099": "New Orleans Cartage-Control, New Orleans, Louisiana",
  "2101": "Port Arthur, Texas",
  "2102": "Sabine, Texas",
  "2103": "Orange, Texas",
  "2104": "Beaumont, Texas",
  "2105": "Lake Charles, Louisiana",
  "2150": "Border Patrol Sector, Yuma, Arizona",
  "2151": "Blythe California Border Patrol, Blythe, California",
  "2152": "Yuma Arizona Border Patrol, Yuma, Arizona",
  "2153": "Wellton Arizona Border Patrol, Wellton, Arizona",
  "2201": "Galveston, Texas",
  "2204": "Freeport, Texas",
  "2205": "Corpus Christi, Texas",
  "2208": "Port Lavaca, Texas",
  "2250": "Border Patrol Sector, Laredo, Texas",
  "2251": "Laredo Del Mar Border Patrol, Laredo, Texas",
  "2252": "Cotulla Texas Border Patrol, Cotulla, Texas",
  "2253": "Hebbronville Texas Border Patrol, Hebbronville, Texas",
  "2254": "Laredo South Border Patrol, Laredo, Texas",
  "2255": "Dallas Border Patrol, Euless, Texas",
  "2256": "Freer Texas Border Patrol, Freer, Texas",
  "2257": "San Antonio Border Patrol, San Antonio, Texas",
  "2258": "Zapata Texas Border Patrol, Zapata, Texas",
  "2301": "Brownsville, Texas",
  "2302": "Del Rio, Texas",
  "2303": "Eagle Pass, Texas",
  "2304": "Laredo, Texas",
  "2305": "Hidalgo, Texas",
  "2307": "Rio Grande City, Texas",
  "2308": "San Antonio, Texas",
  "2309": "Progresso, Texas",
  "2310": "Roma, Texas",
  "2330": "Harlingen, Texas",
  "2350": "Border Patrol Sector, Del Rio, Texas",
  "2351": "Comstock Border Patrol, Comstock, Texas",
  "2352": "Carrizo Springs Border Patrol, Carrizo Springs, Texas",
  "2353": "Del Rio Border Patrol, Del Rio, Texas",
  "2354": "Eagle Pass Border Patrol, Eagle Pass, Texas",
  "2355": "Brackettville Border Patrol, Brackettville, Texas",
  "2356": "Uvalde Texas Border Patrol, Uvalde, Texas",
  "2357": "Rocksprings Border Patrol, Rocksprings, Texas",
  "2358": "Llano Texas Border Patrol, Llano, Texas",
  "2359": "San Angelo Border Patrol, San Angelo, Texas",
  "2360": "Abilene Texas Border Patrol, Abilene, Texas",
  "2381": "Edinburg International Airport, Edinburg, Texas",
  "2382": "Midland International Airport, Midland, Texas",
  "2393": "Brownsville-Cartage Control, Brownsville, Texas",
  "2394": "Del Rio-Cartage Control, Del Rio, Texas",
  "2395": "Eagle Pass-Cartage Control, Eagle Pass, Texas",
  "2396": "San Antonio-Cartage Control, San Antonio, Texas",
  "2397": "Roma-Cartage Control, Roma, Texas",
  "2398": "Hidalgo Cartage Control, Pharr, Texas",
  "2399": "Laredo Cartage Control, Laredo, Texas",
  "2401": "El Paso District, El Paso, Texas",
  "2402": "El Paso, Texas",
  "2403": "Presidio, Texas",
  "2404": "Fabens, Texas",
  "2406": "Columbus, New Mexico",
  "2407": "Albuquerque, New Mexico",
  "2408": "Santa Teresa, New Mexico",
  "2420": "Deming, New Mexico",
  "2421": "Las Cruces, New Mexico",
  "2422": "Alamogordo, New Mexico",
  "2423": "Carlsbad, New Mexico",
  "2424": "Alpine, Texas",
  "2425": "Midland, Texas",
  "2426": "Van Horn, Texas",
  "2427": "Marfa, Texas",
  "2450": "Border Patrol Sector, El Paso, Texas",
  "2451": "Lordsburg New Mexico Border Patrol, Lordsburg, New Mexico",
  "2452": "Truth or Cons Border Patrol, Truth or Cons, New Mexico",
  "2453": "Las Cruces Border Patrol, Las Cruces, New Mexico",
  "2454": "El Paso Border Patrol, El Paso, Texas",
  "2455": "Fabens Texas Border Patrol, Fabens, Texas",
  "2456": "Alamogordo Border Patrol, Alamogordo, New Mexico",
  "2457": "Fort Hancock Texas Border Patrol, Fort Hancock, Texas",
  "2458": "Carlsbad New Mexico Border Patrol, Carlsbad, New Mexico",
  "2459": "Deming New Mexico Border Patrol, Deming, New Mexico",
  "2460": "Silver City New Mexico Border Patrol, Silver City, New Mexico",
  "2461": "Ysleta Border Patrol, El Paso, Texas",
  "2462": "Albuquerque Border Patrol, Albuquerque, New Mexico",
  "2463": "Santa Teresa Border Patrol, Santa Teresa, New Mexico",
  "2479": "El Paso International Airport, Texas",
  "2481": "Santa Teresa Airport, Santa Teresa, New Mexico",
  "2482": "Roswell Industrial Airport, Roswell, New Mexico",
  "2499": "El Paso Cartage Control, El Paso, Texas",
  "2501": "San Diego, California",
  "2502": "Andrade, California",
  "2503": "Calexico, California",
  "2504": "San Ysidro, California",
  "2505": "Tecate, California",
  "2506": "Otay Mesa Station, California",
  "2507": "Calexico-East, California",
  "2520": "Oceanside, California",
  "2521": "El Centro, California",
  "2550": "Border Patrol Sector, El Centro, California",
  "2551": "Indio California Border Patrol, Indio, California",
  "2552": "El Centrol California Border Patrol, El Centrol, California",
  "2553": "Riverside California Border Patrol, Riverside, California",
  "2554": "Calexico California Border Patrol, Calexico, California",
  "2601": "Douglas, Arizona",
  "2602": "Lukeville, Arizona",
  "2603": "Naco, Arizona",
  "2604": "Nogales, Arizona",
  "2605": "Phoenix, Arizona",
  "2606": "Sasabe, Arizona",
  "2607": "Sells, Arizona",
  "2608": "San Luis, Arizona",
  "2609": "Tucson, Arizona",
  "2610": "Sierra Vista, Arizona",
  "2611": "Yuma, Arizona",
  "2620": "Flagstaff, Arizona",
  "2621": "Kingman, Arizona",
  "2650": "Border Patrol Sector, Tucson, Arizona",
  "2651": "Casa Grande Arizona Border Patrol, Casa Grande, Arizona",
  "2652": "Tucson Arizona Border Patrol, Tucson, Arizona",
  "2653": "Nogales Arizona Border Patrol, Nogales, Arizona",
  "2654": "Willcox Arizona Border Patrol, Willcox, Arizona",
  "2655": "Douglas Arizona Border Patrol, Douglas, Arizona",
  "2656": "Ajo Arizona Border Patrol, Why, Arizona",
  "2657": "Naco Border Patrol, Bisbee, Arizona",
  "2658": "Sonoita Arizona Border Patrol, Sonoita, Arizona",
  "2681": "Scottsdale User Fee Airport, Scottsdale, Arizona",
  "2682": "Williams Gateway Airport, Mesa, Arizona",
  "2699": "Nogales Cartage Control, Nogales, Arizona",
  "2704": "Los Angeles, California",
  "2705": "Santa Ana/Orange, Santa Ana, California",
  "2706": "Bakersfield, California",
  "2707": "Port San Luis, California",
  "2709": "Long Beach, California",
  "2711": "El Segundo, California",
  "2712": "Ventura, California",
  "2713": "Port Hueneme, California",
  "2714": "San Bernardino, California",
  "2715": "Capitan, California",
  "2719": "Morro Bay, California",
  "2720": "Los Angeles International Airport, Los Angeles, California",
  "2721": "Ontario International Airport, Ontario, California",
  "2722": "Las Vegas, NV",
  "2755": "Los Angeles Alternate, Los Angeles, California",
  "2770": "DHL Worldwide, Los Angeles, California",
  "2771": "Ogden-Allied, Los Angeles, California",
  "2772": "Gateway Freight Services Inc., Los Angeles, California",
  "2773": "Air Cargo Handling Services, Palm Springs, California",
  "2774": "Virgin Atlantic Cargo, Los Angeles, California",
  "2775": "TNT Express Worldwide, Los Angeles, California",
  "2776": "IBC Pacific, Los Angeles, California",
  "2779": "Los Angeles International Airport, Los Angeles, California",
  "2783": "Southern California Logistics Airport Victorville, California",
  "2795": "UPS, Ontario, California",
  "2801": "San Francisco International Airport, San Francisco, California",
  "2802": "Eureka, California",
  "2803": "Fresno, California",
  "2805": "Monterey, California",
  "2809": "San Francisco, California",
  "2810": "Stockton, California",
  "2811": "Oakland, California",
  "2812": "Richmond, California",
  "2813": "Alameda, California",
  "2815": "Crockett, California",
  "2816": "Sacramento, California",
  "2817": "Redding, California",
  "2818": "San Francisco IAP, San Francisco, California",
  "2819": "Ogden, Utah",
  "2820": "Martinez, California",
  "2821": "Redwood City, California",
  "2822": "Provo, Utah",
  "2823": "St. George, Utah",
  "2827": "Selby, California",
  "2828": "San Joaquin River, California",
  "2829": "San Pablo Bay, California",
  "2830": "Carquinez Strait, California",
  "2831": "Suisun Bay, California",
  "2833": "Reno, Nevada",
  "2834": "San Jose International, San Francisco, California",
  "2850": "Border Patrol Sector, Dublin, California",
  "2851": "Sacramento Border Patrol, Sacramento, California",
  "2852": "Stockton California Border Patrol, Stockton, California",
  "2853": "Fresno California Border Patrol, Fresno, California",
  "2854": "Bakersfield California Border Patrol, Bakersfield, California",
  "2855": "San Luis Obispo Border Patrol, San Luis, Obispo, California",
  "2870": "DHL Worldwide Express, San Francisco, California",
  "2871": "Aircargo Handling Services, San Francisco, California",
  "2872": "TNT Skypak, San Francisco, California",
  "2873": "IBC Pacific, Burlingame, California",
  "2881": "Sacramento International Airport, Sacramento, California",
  "2895": "Federal Express Courier Facility, Oakland, California",
  "2901": "Astoria, Oregon",
  "2902": "Newport, Oregon",
  "2903": "Coos Bay, Oregon",
  "2904": "Portland, Oregon",
  "2905": "Longview, Washington",
  "2907": "Boise, Idaho",
  "2908": "Vancouver, Washington",
  "2909": "Kalama, Washington",
  "2910": "Portland International Airport, Portland, Washington",
  "2911": "Twin Falls, Idaho",
  "2912": "Idaho Falls, Idaho",
  "2913": "Pueblo, Colorado",
  "2914": "Durango, Colorado",
  "2915": "Alamosa, Colorado",
  "2916": "Grand Junction, Colorado",
  "2917": "Glenwood Springs, Colorado",
  "2918": "Craig, Colorado",
  "2920": "Cheyenne, Wyoming",
  "2921": "Casper, Wyoming",
  "2981": "Kingsley Field, Klamath Falls, Oregon",
  "2982": "Rogue Valley/Medford Airport, Medford, Oregon",
  "2991": "Federal Express Courier, Portland, Oregon",
  "3001": "Seattle, Washington",
  "3002": "Tacoma, Washington",
  "3003": "Aberdeen, Washington",
  "3004": "Blaine, Washington",
  "3005": "Bellingham, Washington",
  "3006": "Everett, Washington",
  "3007": "Port Angeles, Washington",
  "3008": "Port Townsend, Washington",
  "3009": "Sumas, Washington",
  "3010": "Anacortes, Washington",
  "3011": "Nighthawk, Washington",
  "3012": "Danville, Washington",
  "3013": "Ferry, Washington",
  "3014": "Friday Harbor, Washington",
  "3015": "Boundary, Washington",
  "3016": "Laurier, Washington",
  "3017": "Point Roberts, Washington",
  "3018": "Kenmore Air Harbor, Washington",
  "3019": "Oroville, Washington",
  "3020": "Frontier, Washington",
  "3021": "South Bend-Raymond, Washington",
  "3022": "Spokane, Washington",
  "3023": "Lynden, Washington",
  "3024": "Wenatchee, Washington",
  "3025": "Metaline Falls, Washington",
  "3026": "Olympia, Washington",
  "3027": "Neah Bay, Washington",
  "3028": "Yakima, Washington",
  "3029": "Seattle-Tacoma International Airport, Seattle, Washington",
  "3030": "Pasco, Washington",
  "3050": "Border Patrol Sector, Blaine, Washington",
  "3051": "Blaine Washington Border Patrol, Blaine, Washington",
  "3052": "Lynden Washington Border Patrol, Lynden, Washington",
  "3053": "Bellingham Border Patrol, Bellingham, Washington",
  "3054": "Port Angeles Border Patrol, Port Angeles, Washington",
  "3071": "UPS, Seattle, Washington",
  "3072": "Avion Brokers @ Seatac, Seatac, Washington",
  "3073": "DHL Worldwide Express, Seatac, Washington",
  "3074": "Airborne Express @ Seatac, Seatac, Washington",
  "3078": "Spokane International Airport, Spokane, Washington",
  "3079": "Boeing Field/King County Airport, Seattle, Washington",
  "3081": "Yakima Air Terminal, Yakima, Washington",
  "3082": "Grant County Airport, Moses Lake, Washington",
  "3095": "UPS Courier Hub, Seatac, Washington",
  "3099": "Port of Puget Sound, Seattle, Washington",
  "3101": "Juneau, Alaska",
  "3102": "Ketchikan, Alaska",
  "3103": "Skagway, Alaska",
  "3104": "Alcan, Alaska",
  "3105": "Wrangell, Alaska",
  "3106": "Dalton Cache, Alaska",
  "3107": "Valdez, Alaska",
  "3111": "Fairbanks, Alaska",
  "3112": "Petersburg, Alaska",
  "3115": "Sitka, Alaska",
  "3124": "Pelican, Alaska",
  "3126": "Anchorage, Alaska",
  "3127": "Kodiak, Alaska",
  "3181": "Saint Paul Airport, Anchorage, Alaska",
  "3195": "Federal Express Courier, Anchorage, Alaska",
  "3196": "UPS Courier Hub, Anchorage, Alaska",
  "3201": "Honolulu, Hawaii",
  "3202": "Hilo, Hawaii",
  "3203": "Kahului, Hawaii",
  "3204": "Nawiliwili-Port Allen, Hawaii",
  "3205": "Honolulu International Airport, Honolulu, Hawaii",
  "3206": "Kona, Hawaii",
  "3207": "Guam Preclearance, San Francisco, California",
  "3208": "North Mariana Island, Guam",
  "3209": "American Samoa, Guam",
  "3210": "Guam",
  "3279": "Honolulu International Airport, Honolulu, Hawaii",
  "3295": "Honolulu Airport, Honolulu, Hawaii",
  "3301": "Raymond, Montana",
  "3302": "Eastport, Idaho",
  "3303": "Salt Lake City, Utah",
  "3304": "Great Falls, Montana",
  "3305": "Butte, Montana",
  "3306": "Turner, Montana",
  "3307": "Denver, Coloroda",
  "3308": "Porthill, Idaho",
  "3309": "Scoby, Montana",
  "3310": "Sweetgrass, Montana",
  "3312": "Whitetail, Montana",
  "3316": "Piegan, Montana",
  "3317": "Opheim, Montana",
  "3318": "Roosville, Montana",
  "3319": "Morgan, Montana",
  "3321": "Whitlash, Montana",
  "3322": "Del Bonita, Montana",
  "3323": "Wildhorse, Montana",
  "3324": "Kalispell Airport, Montana",
  "3325": "Willow Creek, Montana",
  "3326": "Billings, Montana",
  "3327": "Vancouver, BC, Canada",
  "3328": "Calgary, Alberta, Canada",
  "3329": "Edmonton, Alberta, Canada",
  "3331": "Opheim, Montana",
  "3348": "Helena, Montana",
  "3350": "Border Patrol Sector, Havre, Montana",
  "3351": "Havre Montana Border Patrol, Havre, Montana",
  "3352": "Malta Montana Border Patrol, Malta, Montana",
  "3353": "Billings Border Patrol, Billings Montana",
  "3354": "Twin Falls Border Patrol, Twin Falls, Idaho",
  "3355": "Shelby Montana Border Patrol, Shelby, Montana",
  "3356": "Sweetgrass Montana Border Patrol, Sweetgrass, Montana",
  "3357": "St. Mary Montana Border Patrol, Babb, Montana",
  "3358": "Plentywood Montana Border Patrol, Plentywood, Montana",
  "3359": "Scobey Montana Border Patrol, Scobey, Montana",
  "3381": "Missoula User Fee, Missoula, Montana",
  "3382": "Natrona County International Airport, Wyoming",
  "3383": "Jeffco User Fee Airport, Broofield, Colorado",
  "3384": "Arapahoe County Public Airport, Englewood, Colorado",
  "3385": "Eagle County Regional Airport, Gypsum, Colorado",
  "3401": "Pembina, North Dakota",
  "3403": "Portal, North Dakota",
  "3404": "Neche, North Dakota",
  "3405": "St. John, North Dakota",
  "3406": "Northgate, North Dakota",
  "3407": "Walhalla, North Dakota",
  "3408": "Hannah, North Dakota",
  "3409": "Sarles, North Dakota",
  "3410": "Ambrose, North Dakota",
  "3411": "Fargo, North Dakota",
  "3412": "Fargo, Grand Forks, North Dakota",
  "3413": "Antler, North Dakota",
  "3414": "Sherwood, North Dakota",
  "3415": "Hansboro, North Dakota",
  "3416": "Maida, North Dakota",
  "3417": "Fortuna, North Dakota",
  "3419": "Westhope, North Dakota",
  "3420": "Noonan, North Dakota",
  "3421": "Carbury, North Dakota",
  "3422": "Dunseith, North Dakota",
  "3423": "Warroad, Minnesota",
  "3424": "Baudette, Minnesota",
  "3425": "Pinecreek, Minnesota",
  "3426": "Roseau, Minnesota",
  "3427": "Grand Forks Airport, Grand Forks, North Dakota",
  "3428": "Winnipeg International Airport, Winnipeg, Canada",
  "3429": "Crane Lake, Minnesota",
  "3430": "Lancaster, Minnesota",
  "3431": "Minot, North Dakota",
  "3432": "Grand Forks, North Dakota",
  "3450": "Border Patrol Sector, Grand Forks, North Dakota",
  "3451": "Grand Forks Border Patrol, Grand Forks, North Dakota",
  "3452": "Portal North Dakota Border Patrol, Portal, North Dakota",
  "3453": "Bottineau Border Patrol, Bottineau, North Dakota",
  "3454": "Pembina (Noyes) Border Patrol, Hallock, Minnesota",
  "3455": "International Falls Border Patrol, International Falls, Minnesota",
  "3456": "Warroad Border Patrol, Warroad, Minnesota",
  "3457": "Duluth Border Patrol, Duluth, Minnesota",
  "3458": "Grand Marais Border Patrol, Grand Marais, Minnesota",
  "3481": "Hector International Airport, Fargo, North Dakota",
  "3499": "Pembina Cartage Control, Pembina, North Dakota",
  "3501": "Minneapolis-St. Paul, Minnesota",
  "3502": "Sioux Falls, South Dakota",
  "3503": "Rapid City, South Dakota",
  "3505": "Cedar Rapids, Iowa",
  "3506": "Sioux City, Iowa",
  "3507": "Grand Island, Nebraska",
  "3508": "North Platte, Nebraska",
  "3510": "Duluth, Wisconsin",
  "3511": "Ashland, Wisconsin",
  "3512": "Omaha, Nebraska",
  "3513": "Des Moines, Iowa",
  "3578": "Minneapolis-St. Paul Airport, Minnesota",
  "3579": "Joe Foss Field Airport, South Dakota",
  "3581": "Rochester, Minnesota User Fee Airport",
  "3601": "Duluth, Minnesota",
  "3602": "Ashland, Wisconsin",
  "3604": "International Falls/Rainer, Minnesota",
  "3608": "Superior, Wisconsin",
  "3613": "Grand Portage, Minnesota",
  "3614": "Silver Bay, Minnesota",
  "3701": "Milwaukee, Wisconsin",
  "3702": "Marinette, Wisconsin",
  "3703": "Green Bay, Wisconsin",
  "3706": "Manitowoc, Wisconsin",
  "3708": "Racine, Wisconsin",
  "3801": "Detroit, Michigan",
  "3802": "Port Huron, Michigan",
  "3803": "Sault Ste Marie, Michigan",
  "3804": "Saginaw/Bay City, Michigan",
  "3805": "Battle Creek, Michigan",
  "3806": "Grand Rapids, Michigan",
  "3807": "Detroit Metropolitan Airport, Michigan",
  "3808": "Escanaba, Michigan",
  "3809": "Marquette, Michigan",
  "3814": "Algonac, Michigan",
  "3815": "Muskegon, Michigan",
  "3816": "Grand Haven, Michigan",
  "3818": "Rogers City, Michigan",
  "3819": "Detour City, Michigan",
  "3820": "Mackinac Island, Michigan",
  "3822": "South Haven, Michigan",
  "3842": "Presque Island, Michigan",
  "3843": "Alpena, Michigan",
  "3844": "Ferrysburg, Michigan",
  "3850": "Border Patrol Sector, Selfridge Angb, Michigan",
  "3851": "Detroit Border Patrol, Detroit, Michigan",
  "3852": "Sault Ste Marie Border Patrol, Sault Ste Marie, Michigan",
  "3853": "Trenton Border Patrol, Trenton, Michigan",
  "3854": "Port Huron Border Patrol, Marysville, Michigan",
  "3855": "Grand Rapids Border Patrol, Holland, Michigan",
  "3879": "Detroit Metro Airport, Michigan",
  "3881": "Oakland/Pontiac Airport, Detroit, Michigan",
  "3882": "Willow Run Airport, Ypsilanti, Michigan",
  "3901": "Chicago, Illinois",
  "3902": "Peoria, Illinois",
  "3903": "Omaha, Nebraska",
  "3904": "East Chicago, Indiana",
  "3905": "Gary, Indiana",
  "3906": "O\u2019Hara International Airport, Chicago, Illinois",
  "3907": "Des Moines, Iowa",
  "3908": "Davenport, IA-Rock Island, Milan, Illinois",
  "3909": "Rockford Airport, Rockford, Illinois",
  "3910": "Midway International Airport, Chicago, Illinois",
  "3911": "Springfield, Illinois",
  "3979": "Epply Airfield Airport, Nebraska",
  "3981": "Waukegan Regional Airport, Waukegan, Illinois",
  "3982": "Greater Rockford Airport, Rockford, Illinois",
  "3983": "Pal-Waukee User Fee Airport, Wheeling, Illinois",
  "3984": "Dupage Airport Authority, West Chicago, Illinois",
  "3985": "Decatur User Fee Airport, Decatur, Illinois",
  "3987": "UFA UI Willard Airport, Savoy, Illinois",
  "3991": "Nippon Courier Hub, Chicago, Illinois",
  "4101": "Cleveland, Ohio",
  "4102": "Cincinnati, Ohio",
  "4103": "Columbus, Ohio",
  "4104": "Dayton, Ohio",
  "4105": "Toledo, Ohio",
  "4106": "Erie, Pennsylvania",
  "4107": "Northern, Kentucky",
  "4108": "& 4122 Ashtabula, Ohio",
  "4109": "& 4122 Conneaut, Ohio",
  "4110": "Indianapolis, Indiana",
  "4111": "Fairport Harbor, Ohio",
  "4112": "Akron, Ohio",
  "4113": "Evansville, Indiana",
  "4114": "Lawrenceburg, Indiana",
  "4115": "Louisville, Kentucky",
  "4116": "Owensboro-Evansville, Indiana",
  "4122": "Ashtabula/Conneaut, Ohio",
  "4130": "London, Kentucky",
  "4131": "Bowling Green, Kentucky",
  "4170": "Burlington Air Express, Toledo, Ohio",
  "4181": "Airborne Air Park, Wilmington, Ohio",
  "4182": "Rickenbacker Airport, Columbus, Ohio",
  "4183": "Fort Wayne Airport, Fort Wayne, Indiana",
  "4184": "Bluegrass Airport, Lexington, Kentucky",
  "4185": "Hulman Regional Airport, Terre Haute, Indiana",
  "4191": "Airborne Express, Wilmington, Ohio",
  "4192": "Burlington AIT Express, Toledo, Ohio",
  "4195": "Emery Courier, Vandalia, Ohio",
  "4196": "UPS Courier, Louisville, Kentucky",
  "4197": "DHL Courier, Cincinnati, Ohio",
  "4198": "Federal Express Hub, Indianapolis, Indiana",
  "4501": "Kansas City, Missouri",
  "4502": "St. Joseph, Missouri",
  "4503": "St. Louis, Missouri",
  "4504": "Wichita, Kansas",
  "4505": "Springfield, Missouri",
  "4506": "Spirit Of St. Louis Airport, St. Louis, Missouri",
  "4601": "New York/Newark Area, Newark, New Jersey",
  "4602": "Perth Amboy, New Jersey",
  "4670": "UPS, Newark, New Jersey",
  "4671": "Federal Express, Newark, New Jersey",
  "4681": "Morristown Airport, Morristown, New Jersey",
  "4701": "John F. Kennedy Airport, Jamaica, New York",
  "4702": "John F. Kennedy Airport, Jamaica, New York",
  "4755": "JFK Alternate, Jamaica, New York",
  "4770": "Federal Express Corp., Jamaica, New York",
  "4771": "NYACC, Jamaica, New York",
  "4772": "DHL Airways, Jamaica, New York",
  "4773": "Emery Worldwide, Jamaica, New York",
  "4774": "Air France, Jamaica, New York",
  "4775": "Dworkin/Cosell Courier, Jamaica, New York",
  "4776": "Swissair (Skyracer), Jamaica, New York",
  "4777": "Alitalia (Aliexpress), Jamaica, New York",
  "4778": "TNT Skypak, Jamaica, New York",
  "4779": "JFK International Airport, New York",
  "4901": "Aguadilla, Puerto Rico",
  "4904": "Fajardo, Puerto Rico",
  "4905": "Guanica, Puerto Rico",
  "4906": "Humacao, Puerto Rico",
  "4907": "Mayaguez, Puerto Rico",
  "4908": "Ponce, Puerto Rico",
  "4909": "San Juan, Puerto Rico",
  "4911": "Jobos, Puerto Rico",
  "4912": "Guayanilla, Puerto Rico",
  "4913": "San Juan International Airport, Old San Juan, Puerto Rico",
  "4950": "Border Patrol Sector, Aguadilla, Puerto Rico",
  "4951": "Ramey Puerto Rico Border Patrol, Aguadilla, Puerto Rico",
  "4978": "Luis Munoz International Airport, Puerto Rico",
  "4979": "Rafael Hernandez Airport, Puerto Rico",
  "5101": "Charlotte Amalie, Virgin Islands",
  "5102": "Cruz Bay, Virgin Islands",
  "5103": "Coral Bay, Virgin Islands",
  "5104": "Christiansted, Virgin Islands",
  "5105": "Frederiksted, Virgin Islands",
  "5107": "St. Croix, Virgin Islands",
  "5108": "Customs & Border Protection, St. Thomas, Virgin Islands",
  "5201": "Miami, Florida",
  "5202": "Key West, Florida",
  "5203": "Port Everglades, Florida",
  "5204": "West Palm Beach, Florida",
  "5205": "Fort Pierce, Florida",
  "5206": "Miami International Airport , Miami, Florida",
  "5207": "St. Croix, Virgin Islands",
  "5208": "Charlotte Amalie, Virgin Islands",
  "5210": "Fort Lauderdale International Airport, Fort Lauderdale, Florida",
  "5211": "Key Largo, Florida",
  "5212": "Pembroke Pines, Florida",
  "5250": "Border Patrol Sector, Pembroke Pines, Florida",
  "5251": "Miami Border Patrol, Pembroke Pines, Florida",
  "5252": "West Palm Beach Border Patrol, West Palm Beach, Florida",
  "5255": "Miami Alternate, Miami, Florida",
  "5270": "International Courier Association, Miami, Florida",
  "5271": "DHL Worldwide Express, Miami, Florida",
  "5272": "Miami International Airport, Cargo Facilities Services, Inc., Miami, Florida",
  "5273": "UPS Miami International Airport, Miami, Florida",
  "5295": "UPS Miami International Airport, Miami, Florida",
  "5297": "Fedex Courier Hub, Miami, Florida",
  "5298": "IBC Courier Hub, Miami, Florida",
  "5299": "Miami Seaport Alternate, Miami, Florida",
  "5301": "Houston, Texas",
  "5302": "Dallas, Texas",
  "5303": "Fort Worth, Texas",
  "5304": "Oklahoma City, Oklahoma",
  "5305": "Tulsa, Oklahoma",
  "5306": "Texas City, Texas",
  "5307": "Amarillo, Texas",
  "5308": "Lubbock, Texas",
  "5309": "Houston Intercontinental Airport, Houston, Texas",
  "5310": "Galveston, Texas",
  "5311": "Freeport, Texas",
  "5312": "Corpus Christi, Texas",
  "5313": "Port Lavaca, Texas",
  "5350": "Border Patrol Sector, McAllen, Texas",
  "5351": "Mercedes (Weslaco) Border Patrol, Weslaco, Texas",
  "5352": "Falfurrias Border Patrol, Falfurrias, Texas",
  "5353": "Rio Grande City Border Patrol, Rio Grande, Texas",
  "5354": "McAllen Texas Border Patrol, McAllen, Texas",
  "5355": "Brownsville Border Patrol, Brownsville, Texas",
  "5356": "Harlingen Texas Border Patrol, Harlingen, Texas",
  "5357": "Kingsville Texas Border Patrol, Kingsville, Texas",
  "5358": "Fort Brown Texas Border Patrol, Brownsville, Texas",
  "5359": "Corpus Christi Border Patrol, Corpus Christi, Texas",
  "5379": "George Bush Intercontinental Airport, Houston Texas",
  "5401": "Washington, District of Columbia",
  "5402": "Alexandria, Virginia",
  "5501": "Dallas/Ft. Worth Airport, Texas",
  "5502": "Amarillo, Texas",
  "5503": "Lubbock, Texas",
  "5504": "Oklahoma City, Oklahoma",
  "5505": "Tulsa, Oklahoma",
  "5506": "Austin, Texas",
  "5507": "San Antonio, Texas",
  "5520": "Abilene, Texas",
  "5521": "San Angelo, Texas",
  "5550": "Border Patrol Sector, Marfa, Texas",
  "5551": "Lubbock Border Patrol, Lubbock, Texas",
  "5552": "Amarillo Border Patrol, Amarillo, Texas",
  "5553": "Presidio Texas Border Patrol, Presidio, Texas",
  "5554": "Marfa Texas Border Patrol, Marfa, Texas",
  "5555": "Pecos Texas Border Patrol, Pecos, Texas",
  "5556": "Fort Stockton Border Patrol, Fort Stockton, Texas",
  "5557": "Sanderson Texas Border Patrol, Sanderson, Texas",
  "5558": "Alpine Texas Border Patrol, Alpine, Texas",
  "5559": "Big Bend Border Patrol, Big Bend, Texas",
  "5560": "Sierra Blanca Border Patrol, Sierra Blanca, Texas",
  "5561": "Van Horn Texas Border Patrol, Van Horn, Texas",
  "5562": "Midland Texas Border Patrol, Midland, Texas",
  "5578": "San Antonio International Airport, San Antonio, Texas",
  "5579": "Austin-Bergstrom International Airport, Austin, Texas",
  "5582": "Midland International Airport, Midland, Texas",
  "5583": "Fort Worth Alliance Airport, Fort Worth, Texas",
  "5584": "Addison Airport, Addison, Texas",
  "5585": "Collin County Regional Airport, McKinney, Texas",
  "5657": "El Cajon (Area I) Border Patrol, El Cajon, California",
  "5658": "Imperial Beach, California",
  "5750": "Border Patrol Sector, Spokane, Washington",
  "5751": "Spokane Border Patrol, Spokane, Washington",
  "5752": "Pasco Washington Border Patrol, Richland, Washington",
  "5753": "Oroville Washington Border Patrol, Oroville, Washington",
  "5754": "Wenatchee Washington Border Patrol, Wenatchee, Washington",
  "5755": "Colville Washington Border Patrol, Colville, Washington",
  "5756": "Bonners Ferry Idaho Border Patrol, Bonners Ferry, Idaho",
  "5757": "Whitefish Montana Border Patrol, Whitefish, Montana",
  "5758": "Eureka Montana Border Patrol, Eureka, Montana",
  "7100": "Northeast Region, Boston, Massachusetts",
  "7121": "Montreal Quebec Canada, Montreal, Canada",
  "7122": "Toronto Ontario Canada, Toronto, Canada",
  "7400": "Southeast Region, Miami, Florida",
  "7401": "CBP St. Thomas Preclearance, St. Thomas, Virgin Islands",
  "7404": "CBP St. Croix Preclearance, St. Croix, Virgin Islands",
  "7421": "CBP Bermuda Preclearance, Washington, DC",
  "7422": "CBP Freeport Preclearance, Washington, DC",
  "7423": "CBP, Nassau Preclearance, Washington, DC",
  "7424": "CBP, Aruba Preclearance, Washington, DC",
  "7500": "South Central Region, New Orleans, Louisiana",
  "7541": "Dublin, IE Preclearance, Washington, DC",
  "7542": "Shannon IE Preclearance, Washington, DC",
  "7600": "Southwest Region, Houston, Texas",
  "7700": "Pacific Region, Long Beach, California",
  "7728": "Pacific Region, San Francisco, California",
  "7729": "Pacific Region, San Francisco, California",
  "7900": "North Central Region, Chicago, Illinois",
  "7922": "CBP Vancouver Preclear, Washington, DC",
  "7923": "CBP Calgary Preclear, Washington, DC",
  "7924": "CBP Edmonton Preclear, Washington, DC",
  "7925": "CBP Montreal Preclear, Washington, DC",
  "7926": "CBP Toronto Preclear, Washington, DC",
  "7928": "CBP Winnipeg Preclear, Washington, DC",
  "7929": "CBP Ottawa Preclear, Washington, DC",
  "7930": "CBP Victoria Preclear, Washington, DC",
  "9232": "Calgary, Alberta"
}
